import React, { CSSProperties, FC, ReactNode, useEffect, useRef, useState } from "react";
import { genClasses } from "utils/textHelpers";
import ReactDOM from "react-dom";

interface IProps {
  tips: string | React.ReactNode;
  style?: CSSProperties;
  className?: string;
  horizontal?: boolean;
  white?: boolean;
  children: ReactNode;
  containerStyle?: CSSProperties;
  disabled?: boolean;
}

const ToolTip: FC<IProps> = ({
  children,
  tips,
  style,
  className,
  horizontal,
  white,
  containerStyle,
  disabled
}) => {
  const [showBubble, setShowBubble] = useState(false);
  const [position, setPosition] = useState(null);
  const [triangleParams, setTriangleParams] = useState(null);

  const containerRef = useRef(null);
  const boxRef = useRef(null);

  useEffect(() => {
    if (showBubble) {
      getBubblePosition();
      getTrianglePosition();
    }
  }, [showBubble]);

  const getBubblePosition = () => {
    const cont = containerRef.current?.getBoundingClientRect();
    const box = boxRef.current?.getBoundingClientRect();

    let topPosition = horizontal ? cont.top : cont?.top + cont?.height + 6;
    let leftPosition = cont?.left - (horizontal ? box.width : cont.width);

    const bubbleHeight = box?.height;

    if (leftPosition < 0) {
      leftPosition = 10;
    } else if (leftPosition + box?.width > window.innerWidth) {
      leftPosition = window.innerWidth - box?.width - 10;
    } else if (!horizontal && (leftPosition < cont.left - box?.width * 0.5 || cont.width < 20)) {
      leftPosition = cont.left - 10;
    }

    setPosition({
      top:
        topPosition + bubbleHeight > window.innerHeight
          ? window.innerHeight - bubbleHeight - 10
          : topPosition,
      left: leftPosition < 0 ? 10 : leftPosition,
      maxWidth: style?.width || 350
    });
  };

  const getTrianglePosition = () => {
    const cont = containerRef.current?.getBoundingClientRect();
    setTriangleParams({
      className: genClasses("bubble-triangle", {
        horizontal: horizontal,
        white: white
      }),
      style: {
        top: horizontal ? cont.top + cont.height * 0.5 : cont.top + cont.height,
        left: cont.left + (horizontal ? -7 : cont.width * 0.25)
      }
    });
  };

  return (
    <>
      <div
        className={`tooltip-container ${className || ""}`}
        style={containerStyle}
        onMouseOver={() => setShowBubble(true)}
        onMouseLeave={() => setShowBubble(false)}
        ref={containerRef}
      >
        {children}
        {showBubble &&
          !disabled &&
          ReactDOM.createPortal(
            <>
              <div {...triangleParams}></div>
              <div
                className={genClasses("tooltip-bubble", {
                  horizontal: horizontal,
                  white: white
                })}
                style={{
                  ...style,
                  ...position
                }}
                dangerouslySetInnerHTML={typeof tips === "string" ? { __html: tips } : null}
                ref={boxRef}
              >
                {typeof tips !== "string" ? tips : null}
              </div>
            </>,
            document.body
          )}
      </div>
    </>
  );
};

export default ToolTip;
